import { IconContainer } from "../../Buttons/IconContainer";
import ClockIcon from "../../../public/images/icons/clock.svg";
import ViewsIcon from "../../../public/images/icons/views.svg";
import Link from "next/link";
import { BunnyCdnImage } from "../../Image/BunnyCdnImage";
import { VerifiedBadge } from "../Badges/VerifiedBadge";

export const MediaItemHeader = ({ mediaListItem }: any) => {
    return (
        <div className="flex items-center p-2 sm:px-[18px] sm:py-[10px] w-full">
            <Link href={`/users/${mediaListItem.user.username}`}>
                <div className="hover:ring hover:ring-2 hover:ring-outline hover:cursor-pointer hover:bg-base-100
                 p-[10px] rounded-[8px] flex flex-row items-center h-full">
                    <div className="bg-base-100 w-[36px] aspect-square relative overflow-hidden rounded-sm 
                ring-primary ring-offset-base-100 ring-2">
                        <BunnyCdnImage priority width={36} height={36} src={mediaListItem.user.avatar} alt="User Avatar" className="absolute inset-0 w-full h-full" />
                    </div>

                    <p className="truncate text-sm sm:text-base font-bold ml-[10px] mr-[5px] flex flex-row items-center gap-x-1">
                        {mediaListItem.user.isVerified &&
                            <VerifiedBadge className="w-5 h-5 sm:w-6 sm:h-6" />
                        }
                        {mediaListItem.user.name || mediaListItem.user.username}
                    </p>
                </div>
            </Link>


            <div className="flex-1 flex items-end justify-end gap-x-4 truncate">
                <IconContainer responsiveText={false} labelClassName="text-sm" label={mediaListItem.views.toLocaleString()}
                    icon={<ViewsIcon className="w-5 h-5 text-primary" />}></IconContainer>
                <IconContainer responsiveText={false} labelClassName="text-sm" label={new Date(mediaListItem.createdAt).toLocaleDateString('en-us', { year: "numeric", month: "short", day: "numeric" })}
                    icon={<ClockIcon className="w-4 h-4 text-primary" />}></IconContainer>
            </div>
        </div>
    )
}